/**
 * Speaker colors — one hue per speaker (via `--speaker-hue`), shared across the
 * transcript, speakers tab, timeline, and toolbar so a speaker is the same color
 * everywhere. OKLCH lightness/chroma live in `.speaker-fill` (globals.css) and
 * the transcript avatar/border rules — one value clears WCAG AA, light and dark.
 */

import type { CSSProperties } from "react";
import { speakerHue } from "@speakai/common/src/utils/speaker-color";

export { speakerHue } from "@speakai/common/src/utils/speaker-color";

/** Inline style setting `--speaker-hue` for `.speaker-fill` consumers. */
export function speakerHueStyle(
  speakerId: string | number | null | undefined,
): CSSProperties {
  return { "--speaker-hue": speakerHue(speakerId) } as CSSProperties;
}
